<template>
  <div class="layer" v-if="detail && info" @click.prevent="onCloseLayer">
    <button class="btnClose"><span class="blind">close</span></button>
    <div class="inner">
      <p class="cf">* {{locale.flightinfo_cf}}</p>
      <div class="flightLogo"><img :src="info.flightLogo" :alt="info.flightName" /></div>
      <div class="info">
        <div class="summary">
          <p class="terminal"><span class="label">TERMINAL</span>{{detail.terminal_orig ? detail.terminal_orig : '-'}}</p>
          <p class="no">{{detail.flightNo}}</p>
          <p class="gate"><span class="label">GATE</span>{{detail.gate_orig ? detail.gate_orig : '-'}}</p>
        </div>
        <div class="scheduleBox">
          <div class="schedule">
            <div class="from">
              <span class="label">From</span>
              <p class="airport">{{info.origin}}</p>
              <p class="time">{{info.departuretHour}}</p>
            </div>
            <div class="to">
              <span class="label">To</span>
              <p class="airport">{{info.destination}}</p>
              <p class="time">{{info.arrivalHour}}</p>
            </div>
          </div>
        </div>
        <ul v-if="detail.codeshare && detail.codeshare.length > 0" class="codeshare">
          <li v-for="code in detail.codeshare"
            :key="code.flightNo">
            {{codeshareMessage(code)}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ScheduleDetail',
  props: [
    'locale',
    'lang',
    'info'
  ],
  computed: {
    ...mapGetters({
      detail: 'flightinfo/getScheduleDetail'
    })
  },
  methods: {
    onCloseLayer (e) {
      const isClose = e.target.closest('.layer .inner') === null
      if (isClose) {
        this.$emit('close')
      }
    },
    codeshareMessage (code) {
      return `[${code.flightNo}] ${code.flightName} ${this.locale.flightinfo_codeshare_message}`
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 360px;
    padding: 0;
    border-radius: 4px;
    overflow: hidden;
    background: none;
  }
  .flightLogo {
    position: relative;
    padding: 15px;
    overflow: hidden;
    text-align: center;
    background-size: 51% 100%;
    background-repeat: no-repeat;
    background-position: 0 0, 100% 0;
    background-image:
      radial-gradient(circle at 0 100%, rgba(255,255,255,0) 0.4em, #fff 0.5em),
      radial-gradient(circle at 100% 100%, rgba(255,255,255,0) 0.4em, #fff 0.5em);
    img {
      height: 50px;
    }
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0.5em;
      right: 0.5em;
      border-top: 1px dashed $color-lgrey;
    }
  }
  .cf {
    font-size: 0.85em;
    color: $color-white;
    margin-bottom: 0.3em;
  }
  .summary {
    display: flex;
    padding: 30px 15px 0;
    font-size: 1.4em;
    font-weight: 700;
    text-align: center;
    > * {
      flex: 1;
    }
    .label {
      display: block;
      font-size: 0.5em;
      font-weight: 500;
      color: $color-lgrey;
    }
    .no {
      flex: 1.5;
      font-size: 1.6em;
    }
  }
  .info {
    position: relative;
    overflow: hidden;
    background-size: 51% 100%;
    background-repeat: no-repeat;
    background-position: 0 0, 100% 0;
    background-image:
      radial-gradient(circle at 0 0, rgba(255,255,255,0) 0.4em, #fff 0.5em),
      radial-gradient(circle at 100% 0, rgba(255,255,255,0) 0.4em, #fff 0.5em);
  }
  .scheduleBox {
    padding: 15px 30px 60px;
  }
  .schedule {
    display: flex;
    position: relative;
    text-align: center;
    padding: 15px 30px;
    border-radius: 12px;
    background-color: $bg-default;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 64px;
      height: 64px;
      background: url('~@/assets/img/ico_plane.png') 50% 50% / contain no-repeat;
      opacity: 0.1;
      transform: translate(-50%, -50%);
    }
    &:after {
      content: "\21C0";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      margin-top: -0.5em;
      font-size: 2em;
      color: $color-dark;
    }
    .label {
      color: $color-grey;
    }
    .to {
      margin-left: auto;
    }
    .airport {
      font-size: 2em;
      font-weight: 700;
      color: $color-dark;
    }
    .time {
      font-size: 1.2em;
    }
  }
  .codeshare {
    padding: 15px;
    font-size: 0.8em;
    color: $color-grey;
    background-color: $bg-default;
    li:before {
      content: "i";
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 2px;
      text-align: center;
      font-family: arial;
      font-size: 11px;
      line-height: 14px;
      color: $color-white;
      border-radius: 100%;
      border: 1px solid $color-grey;
      background-color: $color-grey;
    }
  }
}
</style>
